import { render } from "./BaseTopNav.vue?vue&type=template&id=33c4b4bb&scoped=true"
import script from "./BaseTopNav.vue?vue&type=script&lang=js"
export * from "./BaseTopNav.vue?vue&type=script&lang=js"

import "./BaseTopNav.vue?vue&type=style&index=0&id=33c4b4bb&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c4b4bb"]])

export default __exports__